import { render, staticRenderFns } from "./overviewBoxInfoItem.vue?vue&type=template&id=47cfe3d2&scoped=true&"
import script from "./overviewBoxInfoItem.vue?vue&type=script&lang=js&"
export * from "./overviewBoxInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./overviewBoxInfoItem.vue?vue&type=style&index=0&id=47cfe3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cfe3d2",
  null
  
)

export default component.exports